function DateFormatHelper(inputDateString) {
    const splitter = inputDateString.split('/');
    const OutputDateString = `${splitter[0]}-${splitter[1]}-${splitter[2]}`;
    return OutputDateString;
  }
  
  export default DateFormatHelper;
  